<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ invalid, validate }"
    class="w-full"
  >
    <aproe-layout>
      <template slot="head">
        <h2 class="text-center break-words">
          <span>APROE Waterjet Service Quote Engine</span>
          <img
            class="h-4 -mb-10 -mt-1 inline"
            src="../assets/beta.png"
          >
        </h2>
      </template>
      <template slot="left">
        <div class="w-full">
          <br>
          <div class="w-full flex items-center">
            <form
              class="w-full"
              @submit.prevent="orderId ? null : validate().then(submitOrder)"
            >
              <!--TODO:@peter figure out how better to do the submit with other buttons-->
              <OrderDetails
                :order="order"
                :jobs="jobs"
                :discount-options="discountOptions"
                :services-subtotal="servicesSubtotal"
                :services-final-price="servicesFinalPrice"
                :order-total-price="orderTotalPrice"
                :newsletter="newsletter"
                @handle-change-newsletter="changeNewsletter"
              />
              <div class="flex w-full justify-between">
                <button
                  v-tooltip="'Click here to add another/multiple jobs to this quote.'"
                  type="button"
                  class="btn m-2"
                  :disabled="orderId || (order && order.status)"
                  @click="addJob"
                >
                  Add Job to this Order
                </button>
                <button
                  v-tooltip="'Click here to completely start over and clear the form.'"
                  type="button"
                  class="btn m-2"
                  @click="startOver"
                >
                  Start Over
                </button>
                <div
                  v-if="
                    orderId &&
                      order.status === 'Approved' &&
                      orderStatus !== 'success'
                  "
                  class="w-1/4 m-2"
                >
                  <xn-stripe-checkout-button
                    :disabled="taxRate === null || !order.price"
                    :tax-rate="taxRate"
                    :pay-amount="order.price * (1 + taxRate)"
                    name="Waterjet Cut Parts"
                    :description="
                      'APROE Waterjet cutting for order: ' +
                        String(orderId) +'\r\n'+
                        priceBreakdown
                    "
                    :success-url="currentPath + '/success'"
                    :cancel-url="currentPath"
                    :access-id="orderId"
                  />
                  <p v-show="taxRate === null">
                    Please provide a valid shipping zip above or 94107 for
                    pick-up
                  </p>
                </div>
                <button
                  v-else-if="orderId && order"
                  class="btn m-2"
                  :disabled="
                    orderRequested ||
                      order.status !== 'Completed' ||
                      !jobs.filter(job => job.add_to_order).length > 0
                  "
                  @click="confirmRequestOrder"
                >
                  {{
                    orderRequested
                      ? 'Order Requested'
                      : 'Order These Parts'
                  }}
                </button>
                <!-- Note: div with v-else and v-tooltip is wrapped around
                submit button due to the fact that Safari and Chrome both
                would not display v-tooltip for disabled button -->
                <div v-else v-tooltip="submitQuoteTooltipValue">
                  <input
                    class="btn m-2"
                    type="submit"
                    value="Submit Quote"
                    :disabled="
                      invalid ||
                        requestSending ||
                        jobs.length == 0 ||
                        !hasJobFiles
                    "
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </template>
      <template slot="right">
        <h3 class="text-center">
          <span class="px-1">{{ expandContactInfo ? 'Hide' : 'Show' }} Contact Information</span>
          <i
            :class="`px-1 fas fa-chevron-${expandContactInfo ? 'up' : 'down'} cursor-pointer`"
            @click="toggleExpandContactInfo"
          />
        </h3>
        <section
          v-show="expandContactInfo"
          class="sm:flex"
        >
          <information-text />
          <form
            class="flex flex-col items-start justify-center sm:w-5/6 text-white"
            novalidate
          >
            <h3 class=" uppercase">
              Contact Information
            </h3>
            <p class="text-xs font-bold">Required Fields *</p>
            <xn-input
              v-model="customer.email"
              label="Email"
              :no-placeholder="true"
              type="email"
              :required="true"
            />
            <xn-input
              v-model="customer.name"
              label="Name"
              :no-placeholder="true"
              type="text"
              :required="true"
            />
            <xn-input
              v-model="customer.phone"
              :v-tooltip-prop="'Phone number must be entered following this format xxx-xxx-xxxx'"
              :custom-validation="{
                regex: /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
              }"
              label="Phone"
              placeholder="000-000-0000"
              :no-placeholder="false"
              type="tel"
            />
            <xn-input
              v-model="customer.location.zip"
              label="ZIP"
              :custom-validation="{ regex: /^([0-9]){5}$/ }"
              :no-placeholder="true"
              type="text"
            />
            <br>
          </form>
        </section>
        <xn-waiting :show="requestSending" />
      </template>
    </aproe-layout>
  </ValidationObserver>
</template>

<script>
import XnFormGroup from '../components/primitives/XnFormGroup.vue'
import XnInput from '../components/primitives/XnInput.vue'
import AproeLayout from '../components/structure/layouts/AproeLayout.vue'
//import XnStripeBlock from '../components/primitives/stripe/XnStripeBlock.vue'
import XnStripeCheckoutButton from '../components/primitives/stripe/XnStripeCheckoutButton.vue'
import XnWaiting from '../components/primitives/XnWaiting.vue'
import { ValidationObserver } from 'vee-validate'
import InformationText from '../components/InformationText.vue'
import OrderDetails from '../components/OrderDetails.vue'
import materials from '../plugins/api/materials'
import { exception } from 'vue-gtag'
import GeneralMixins from '../mixins/GeneralMixins.vue'
import CostFactorMixins from '../mixins/CostFactorMixins.vue'

// @ is an alias to /src
export default {
  name: 'Home',
  components: {
    XnInput,
    XnFormGroup,
    AproeLayout,
    //XnStripeBlock,
    XnStripeCheckoutButton,
    XnWaiting,
    ValidationObserver,
    InformationText,
    OrderDetails,
  },
  mixins: [GeneralMixins, CostFactorMixins],
  props: {
    id: { type: String, default: null },
    orderStatus: { type: String, default: null },
  },
  data () {
    return {
      discountOptions: null,
      submitFile: null,
      customer: {
        name: null,
        email: null,
        phone: null,
        location: { zip: null },
      },
      material: null,
      requestSending: false,
      timer: null,
      timerStart: null,
      waitingOnUpdate: false,
      order: {},
      orderId: null,
      orderRequested: false,
      completedList: [
        'Completed',
        'Errored',
        'Approved',
        'Requested',
        'Ordered',
        'Manual',
        'Expired',
      ],
      jobs: [this.blankJob()],
      hasJobFiles: false,
      taxRate: null,
      newsletter: true,
      expandContactInfo: true
    }
  },
  computed: {
    environment () {
      return process.env.NODE_ENV
    },
    currentPath () {
      return window.location.origin + this.$route.path
    },
    disableButton () {
      return (
        !(
          this.submitFile &&
          this.customer &&
          this.material &&
          this.customer.email &&
          this.customer.name
        ) || this.requestSending
      )
    },
    stripePK () {
      return process.env.VUE_APP_STRIPE_PK
    },
    priceBreakdown () {
      if (this.order && this.taxRate) {
        return (
          '\r\nSubtotal: ' +
          this.toCurrency(this.orderTotalPrice) +
          '\r\nTax: ' +
          this.toCurrency(this.orderTotalPrice * this.taxRate) +
          '\r\nTotal: ' +
          this.toCurrency(this.orderTotalPrice * (1 + this.taxRate))
        )
      } else {
        return 'Subtotal: ' + this.toCurrency(this.orderTotalPrice)
      }
    },
    servicesSubtotal () {
      if (this.jobs) {
        return this.jobs
          .filter(job => job.add_to_order || ['Approved'].includes(job.status))
          .map(job => job.price_breakdown['services'])
          .reduce((prev, cur) => prev + cur, 0)
      } else {
        return 0
      }
    },
    materialPrice () {
      if (this.jobs) {
        return this.jobs
          .filter(job => job.add_to_order || ['Approved'].includes(job.status))
          .map(job => job.price_breakdown['material'])
          .reduce((prev, cur) => prev + cur, 0)
      } else {
        return 0
      }
    },
    servicesFinalPrice () {
      if (this.jobs) {
        return this.process_price(
          this.servicesSubtotal,
          this.jobs
            .filter(
              job => job.add_to_order || ['Approved'].includes(job.status)
            )
            .map(job => this.addTime(job.operation_time.split(':')))
            .reduce((prev, cur) => prev + cur, 0),
          this.discountOptions
        )
      } else {
        return 0
      }
    },
    orderTotalPrice () {
      if (!this.order.price) {
        return this.servicesFinalPrice + this.materialPrice
      }
      return this.order.price
    },
    submitQuoteTooltipValue () {
      // this is the same conditional that controls the enabled/disabled status of the button
      if (this.invalid || this.requestSending || this.jobs.length == 0 || !this.hasJobFiles) {
        return {
          content: `
            <p>There is some information missing.  Please double check:</p>
            <ul class="list-disc">
              <li class="ml-4"><b class="font-bold">Required&ast;</b> fields for the contact information above.</li>
              <li class="ml-4"><b class="font-bold">Required&ast;</b> fields for all jobs on this order.</li>
            </ul>
          `,
          html: true
        }
      }
      // if everything is good to go
      return 'Click here if you are ready to submit your quote!'
    }
  },
  watch: {
    jobs: {
      handler: function (val) {
        let self = this
        let allJobs = true
        val.forEach(job => {
          allJobs = allJobs && true
          if (!(job.file && job.filename)) {
            allJobs = false
            self.hasJobFiles = false
            return false
          }
        })
        self.hasJobFiles = allJobs
      },
      deep: true,
    },
    customer: {
      handler: function (val) {
        this.getTaxRate(val.location.zip)
      },
      deep: true,
    },
    id (val) {
      this.orderId = val
      if (!val) {
        this.clearData()
      }
    },
    orderId (val) {
      this.startQuery(val)
    },
  },
  mounted () {
    this.startQuery(this.orderId)
    if (this.orderStatus === 'success') {
      this.$swal(
        'Your order has been completed. You should receive an email with confirmation and we will notify you when it is done.'
      )
    }
    if (this.id) this.orderId = this.id // @marcus this is what I ended up going with to get the order to be pulled in.  it seems to work for now
  },
  beforeDestroy () {
    this.cancelUpdate()
  },
  created () {
    this.getDiscounts()
    this.getTaxRate(this.customer.location.zip)
    this.expandContactInfo = this.$route.path === '/'
  },
  methods: {
    blankJob () {
      return {
        file: null,
        filename: undefined,
        material: undefined,
        params: {
          scale: 1,
          times_cut: 1,
          taper_compensation: false,
          axis_5: false,
          material: undefined,
        },
      }
    },

    getTaxRate (val) {
      if (!(val && val.match(/^([0-9]){5}$/))) {
        this.taxRate = null
        return false
      }
      let self = this
      // console.log(val)
      this.$api.Transactions.getTaxRate(val)
        .then(res => {
          if (res.status === 200) {
            self.taxRate = res.data.rate
            // console.log(self.taxRate)
          } else {
            throw new Error('Error: ' + res.message)
          }
        })
        .catch(err => {
          self.$swal(err.message)
        })
    },
    getDiscounts () {
      /*this really doesn't need loaded on create, can wait for 
      prices to actually come in, but that trigger logic is a 
      bit more complicated. 
      */
      if (!this.discountOptions) {
        let self = this
        this.$api.Transactions.getDiscounts()
          .then(res => {
            if (res.status === 200) {
              self.discountOptions = res.data.discounts
            } else {
              throw new Error('Error: ' + res.message)
            }
          })
          .catch(err => {
            self.$swal(err.message)
          })
      }
    },
    clearData () {
      this.jobs = [this.blankJob()]
      this.order = {}
      this.customer = {
        name: null,
        email: null,
        phone: null,
        location: { zip: null },
      }
    },

    createOrderSummary () {
      const allJobsAdded = this.jobs.every(job => job.add_to_order)
      const jobs = this.jobs
        .filter(job => job.status === 'Completed' && job.add_to_order)
        .map(
          (job, i) =>
            `<li> 
              <p class="text-gray-700 mb-1">Job ${i + 1}: ${job.filename}</p>
              <p class="text-gray-700 pl-2">Count: ${job.params.times_cut}</p>
              <p class="text-gray-700 pl-2">Price: ${this.toCurrency(job.price)}</p>
              </p>
              <br/>
            </li>`
        )
      let summary = '<div><ul class="list-disc text-left">'
      jobs.forEach(job => (summary += job))
      summary +=
        '</ul><p class="text-gray-700 font-semibold">Total Price: ' +
        this.toCurrency(this.orderTotalPrice) + '</p>'
      if (!allJobsAdded) {
        summary += '<p class="pt-1 text-gray-700 text-sm font-semibold">' + 
          'Note: This is a partial order.  Any incomplete or unselected jobs will have to be re-submitted for new quotes.</p>'
      }
      summary += '</div>'
      return summary
    },

    confirmRequestOrder () {
      this.$swal({
        title: 'Order Summary',
        html: this.createOrderSummary(),
        showCancelButton: true,
      }).then(result => {
        if (result.isConfirmed) {
          this.requestOrder()
        }
      })
    },
    requestOrder () {
      let self = this
      let errorMessage = ''
      let successJobs = 0
      self.requestSending = true
      const jobPromises = []
      this.jobs
        .filter(job => job.add_to_order)
        .forEach(job => {
          if (job.status === 'Completed') {
            const jobPromise = self.$api.Job.requestJobOrder(job.combo_id)
            jobPromises.push(jobPromise)
            jobPromise.then(res => {
                if (res.status === 200) {
                  successJobs++
                } else {
                  throw new Error({ message: res.message })
                }
              })
              .catch(err => {
                errorMessage = errorMessage + err.message + ' | '
              })
          } else {
            // console.log('status: ' + job.status)
          }
        })
      
      Promise.allSettled(jobPromises).then(() => {
          self.requestSending = false
          if (successJobs > 0) {
            self.orderRequested = true
            self.$swal(
              'Order Request Sent! You will receive an email from waterjet@aproe.com shortly if it is cleared.'
            )
          }
          if (errorMessage || successJobs === 0) {
            self.$swal(
              'Something went wrong processing your request: ' + errorMessage
            )
          }
      }).catch(_err => {}) // this can be fine-tuned a bit later
      .finally(() => self.requestSending = false)
        

    },
    startQuery (val) {
      if (val || this.orderId) {
        //TODO: not sure why we're using val, can probably remove
        if (this.timer) {
          this.cancelUpdate()
        }
        this.getOrderUpdate()
        this.timerStart = Date.now()
        this.timer = setInterval(this.getOrderUpdate, 1000)
      }
    },
    getOrderUpdate () {
      if (this.timerStart && this.timerStart + 80000 <= Date.now()) {
        this.timerStart = null
        this.cancelUpdate()
        this.$swal(
          'This job has been running for longer than expected. You may consider '
          + 'leaving and waiting for our update email. If you don\'t receive '
          + 'anything within 30 minutes please consider contacting support. You can '
          + 'also refresh the page to keep getting live updates.'
        )
      }
      let self = this
      if (!this.waitingOnUpdate) {
        this.waitingOnUpdate = true
        //Order update should return the order with a status, list of jobs, error (if applicable), and price
        this.$api.Order.getOrderUpdate(this.orderId)
          .then(res => {
            if (res.status === 200) {
              self.order = res.data.order

              self.customer = res.data.customer
              self.jobs = res.data.jobs
              if (self.completedList.includes(self.order.status)) {
                self.cancelUpdate()
              }
              if (self.order.combo_id && self.order.combo_id !== self.orderId) {
                self.waitingOnUpdate = false
                self.orderId = self.order.combo_id
                self.$router.push({ path: `/order/${self.orderId}` })
              }
              if (self.order.status === 'Errored') {
                self.$swal(
                  'Your job has failed to process. Reason: ' + self.order.error
                )
              } else if (self.order.status === 'Completed') {
                if (this.jobs.map(job => job.status).some(status => status === 'Manual')) {
                  self.$swal(
                    'There has been progress on your estimate.  One or more of your jobs cannot be analyzed automatically ' +
                    'and will require a manual estimate.  You will receive an email from waterjet@aproe.com when your estimate is complete.  ' +
                    self.priceBreakdown
                  )
                } else {
                  self.$swal(
                    'Your estimate is complete.\n' +
                    self.priceBreakdown,
                    'Due to the changing costs of materials, quotes will expire after a 48-hour period and will have to be resubmitted.  ' +
                    'If your order requires any manual estimates, the expiration will be 48 hours after the last manual estimate is completed.'
                  )
                }
              } else if (self.order.status === 'Expired') {
                self.$swal(
                  'Your job has expired.  It has been more than 48 hours since your job was quoted.  Please "Start Over" and and submit a new order.'
                )
              }
            } else {
              self.$swal('Something went wrong! ' + res.message)
              self.cancelUpdate()
            }
          })
          .catch(err => {
            self.$swal('Error getting update: ' + err.message)
            self.cancelUpdate()
          })
          .finally(() => {
            self.waitingOnUpdate = false
          })
      }
    },

    cancelUpdate () {
      clearInterval(this.timer)
      this.timer = null
    },
    addJob () {
      this.jobs.push(this.blankJob())
    },
    startOver () {
      this.jobs = [this.blankJob()]
      this.orderRequested = false
      this.requestSending = 0
      this.timerStart = null
      this.expandContactInfo = true
      window.scrollTo(0, 0)
      this.$router.push('/')
    },
    subscribeToMailingList () {
      const formData = new FormData()
      formData.append('email', this.customer.email)
      this.$api.MailingList.subscribeToMailingList(formData)
    },
    submitOrder () {
      if (this.newsletter) this.subscribeToMailingList()
      let self = this
      this.requestSending = true
      const formData = new FormData()
      try {
        this.jobs.forEach(
          (job,index) => formData.append(`file${index}`, job.file, job.filename)

          //TODO: @peter, should we refactor to remove file from the job data as we are passing it through separately (keeping filename of course)
        )
      } catch (e) {
        this.$swal('Failed: make sure all jobs have a file upload.')
        return
      }
      formData.append('customer', JSON.stringify(this.customer))
      formData.append('jobs', JSON.stringify(this.jobs))
      this.$api.Order.requestNewOrder(formData)
        .then(res => {
          if (res.status === 201) {
            self.$swal(res.data.message)
            self.orderId = res.data.order_combo_id
            self.$router.push({ path: `/order/${self.orderId}` })
          } else {
            self.$swal('Something went wrong! ' + res.message)
          }
        })
        .catch(err => {
          self.$swal("Something doesn't look right: " + err.message)
        })
        .finally(() => {
          self.requestSending = false
          this.expandContactInfo = false
        })
    },
    toggleExpandContactInfo () {
      this.expandContactInfo = !this.expandContactInfo
    },
    changeNewsletter(newsletter) {
      this.newsletter = newsletter
    }
  },
}
</script>
<style lang="postcss" scoped>
h2 {
  @apply text-3xl;
}
h3 {
  @apply text-xl;
}
</style>
